// i18n
import { translateInComponent } from 'infras/i18n';
import translations from 'presentations/views/components/pages/EventCancellationPage/i18n.json';

import { GetServerSideProps } from 'next';
import MainDocument from 'presentations/views/components/MainDocument';
import EventCancellationPage from 'presentations/views/components/pages/EventCancellationPage';
import { authorize } from 'presentations/api/auth';
import { get } from 'infras/rest_client';
import { SharedEventDetailItem } from 'presentations/api/schema/event';
import { splitHostAndUsersFromEventType } from 'presentations/views/helpers/event_type';
import { apiPath } from 'presentations/routes/path';
import { EventContactItem } from 'presentations/api/schema/event_contact';
import { SharedEventTypeItem } from 'presentations/api/schema/event_type';
import { TeamItem } from 'presentations/api/schema/team';
import { EventTypeUserListItem } from 'presentations/api/schema/event_type_user';
import { ViewerItem } from 'presentations/api/schema/user';
import { PlanId } from 'domains/models/subscription/planId';

interface ServerProps {
  viewer: ViewerItem | null;
  event: SharedEventDetailItem;
  eventType: SharedEventTypeItem;
  team: TeamItem;
  eventContact: EventContactItem;
  host: EventTypeUserListItem;
}

export const getServerSideProps: GetServerSideProps = async ({
  req,
  res,
  query,
}: any) => {
  const viewer = await authorize(req, res, { isRedirect: false });

  let result;
  result = await get(apiPath(`/v1/events/${query.eventId}`));
  if (!result.isSuccess || !result.data) {
    return { props: { statusCode: 404 } };
  }
  const event: SharedEventDetailItem = result.data;

  result = await get(apiPath(`/v1/guests/event_types/${event.eventTypeId}`));
  if (!result.isSuccess || !result.data) {
    return { props: { statusCode: 404 } };
  }
  const eventType: SharedEventTypeItem = result.data;

  result = await get(apiPath(`/v1/events/${query.eventId}/contact`));
  if (!result.isSuccess || !result.data) {
    return { props: { statusCode: 404 } };
  }
  const eventContact: EventContactItem = result.data;

  result = await get(apiPath(`/v1/teams/${eventType.teamId}`));
  if (!result.isSuccess || !result.data) {
    return { props: { statusCode: 404 } };
  }
  const team: TeamItem = result.data;

  const { host } = splitHostAndUsersFromEventType(eventType.users);
  if (!host) {
    return { props: { statusCode: 403 } };
  }

  const props: ServerProps = {
    viewer: viewer || null,
    event,
    eventType,
    team,
    eventContact,
    host,
  };
  return { props };
};

export default function Page(props: ServerProps) {
  const t = translateInComponent(translations);

  return (
    <MainDocument
      title={t('title', { eventName: props.event.name })}
      userGoogleAnalyticsTrackingId={props.eventType.googleAnalyticsId}
      userMetaPixelTrackingId={props.eventType.metaPixelId}
      isExcludeSiteName={props.eventType.planId !== PlanId.Free}
      isNoIndex={true}
    >
      <EventCancellationPage
        viewer={props.viewer}
        host={props.host}
        event={props.event}
        eventType={props.eventType}
        eventContact={props.eventContact}
        breadcrumbs={[]}
        teamImage={props.team.profileImage}
        teamName={props.team.name}
        confirmText={props.eventType.confirmText}
        isShowHeaderTeamImage={props.eventType.isShowHeaderTeamImage}
      />
    </MainDocument>
  );
}
